import {
    Box,
    Typography,
    Tabs,
    Tab
} from '@mui/material';
import { ComparativeSetDensityNetworkConfigResultsTable } from './ComparativeSetDensityNetworkConfigResultsTable';
import { useState } from 'react';

const ViewComparativeSetDensityNetworkConfigResults = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const comparativeSetID = queryParameters.get("comparative-set")
    const [currentTab, setCurrentTab] = useState('si_sdr')
    const densityNetworkConfigIDList = queryParameters.get("density-network-config-ids").split(';')

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    return (
        <Box>
            <Box sx={{ justifyContent: "space-between", display: "flex" }}>
                <Typography variant="h6">DNC Performance Comparison</Typography>
            </Box>
            <Tabs onChange={handleChange} value={currentTab}>
                <Tab label="SI-SDR" value="si_sdr">SI-SDR</Tab>
                <Tab label="Speech Consolidation Score" value="speech_signal_consolidation_score" />
                <Tab label="Speech Transform Activation Score" value="speech_transform_activation_score" />
                <Tab label="Speech Channel Assignment Score" value="speech_channel_assignment_score" />
            </Tabs>
            <div style={{ height: "750px" }}>
                <ComparativeSetDensityNetworkConfigResultsTable comparative_set_id={comparativeSetID} density_network_config_id_list={densityNetworkConfigIDList} score_metric={currentTab} />
            </div>
        </Box>
    )
}

export default ViewComparativeSetDensityNetworkConfigResults